// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"708267cb","151":"5f6dfb4f","357":"5f0279fb","358":"41b105c6","603":"cf1bd653","642":"e67682a2","751":"13188994","848":"f8451ffd","867":"1a63b56d","979":"b7bf5305"}[chunkId] + ".chunk.js";
};